import { readStreamableValue, StreamableValue } from 'ai/rsc';
import { Pass1LearningPath, Pass2LearningPath } from '../../typesV2';
import { streamMapPass2 } from '../../app/actions/streamMapPass2Action';
import { mergeEmbellishedSectionsIntoLearningPath, SchemaOutput } from './mergePass2';

export async function runMapPass2Stream(
  updateState: (map: Pass2LearningPath) => void,
  jobTitle: string,
  mapSlug: string,
  pass1LearningPath: Pass1LearningPath
): Promise<Pass2LearningPath> {
  let lastPass2Output: Pass2LearningPath | null = null;

  let mapStream = await streamMapPass2(jobTitle, mapSlug, pass1LearningPath);

  const mapStreamValue = readStreamableValue(
    mapStream as StreamableValue<any, Error>
  );

  if (Symbol.asyncIterator in mapStreamValue) {
    for await (const partialPass2Output of mapStreamValue) {
      if (partialPass2Output) {
        const mergedData = mergeEmbellishedSectionsIntoLearningPath(
          pass1LearningPath,
          partialPass2Output as any as Partial<SchemaOutput>
        );
        updateState(mergedData as Pass2LearningPath);
        lastPass2Output = mergedData as Pass2LearningPath;
      }
    }
  } else {
    throw new Error('Stream did not return a value');
  }

  if (!lastPass2Output) {
    throw new Error('No pass 2 output');
  }

  return lastPass2Output;
}
